import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";

export const SiteFooter = () => (
  <footer className="border-t border-white/10" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-8 px-6 py-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <Logo />
        <p className="mt-4 max-w-sm text-sm text-zinc-500">Plataforma para crear, entrenar y vender agentes de IA, modelos locales y software profesional.</p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="text-[11px] uppercase tracking-widest text-zinc-600">Catálogo</p>
        <Link to="/marketplace" className="block text-zinc-400 hover:text-white" data-testid="footer-marketplace">Agentes IA</Link>
        <Link to="/models" className="block text-zinc-400 hover:text-white" data-testid="footer-models">Modelos locales</Link>
        <Link to="/software" className="block text-zinc-400 hover:text-white" data-testid="footer-software">Software</Link>
      </div>
      <div className="space-y-2 text-sm">
        <p className="text-[11px] uppercase tracking-widest text-zinc-600">Crear</p>
        <Link to="/agents/new" className="block text-zinc-400 hover:text-white">Crear agente</Link>
        <Link to="/dashboard" className="block text-zinc-400 hover:text-white">Panel</Link>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-6 py-6 text-xs text-zinc-500 sm:flex-row">
        <p data-testid="footer-copyright">© 2026 E.B.G / CyberCodium · HackLabs. Todos los derechos reservados.</p>
        <p className="font-mono">Pagos seguros con Stripe</p>
      </div>
    </div>
  </footer>
);
